import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import useToken from '../hooks/useToken';
import { API_ENDPOINTS } from '../utils/config';
import Skeleton from './skeleton/Skeleton';

const SidebarCategories = () => {
    const { token } = useToken(); 
    const [categories, setCategories] = useState([]);
    const [hasError, setHasError] = useState(false);
    
    const fetchCategories = useCallback( async () => {
        try {
            const response = await axios.get(
                `${API_ENDPOINTS.CATEGORY_ENDPOINT}/5`,
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if ( response.status === 200 && response.data?.items ) {
                setCategories( response.data.items );
            } else {
                setHasError( true );
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            setHasError(true);
        }
    }, [token]);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    return (
        <div className="common-wrapper mb-4 position-relative">
            <h3 className="mb-4 fw-500 text-uppercase text-4">Trending Categories</h3>
            {hasError ? (
                <p className="text-danger">Failed to load categories. Please try again later.</p>
            ) : (
                <ul className="category_wrapper p-0 m-0">
                    {categories.length > 0 ? (
                        categories.map((category) => (
                        <li key={category.term_id}>
                            <Link
                            to={`/category/${category.slug}`}
                            className="text-2 text-uppercase text-decoration-none fw-600"
                            >
                            {category.name}
                            </Link>
                            <span className="text-2 fw-600">({category.count})</span>
                        </li>
                        ))
                    ) : (
                        <Skeleton type="sidecategories" />
                    )}
                </ul>
            )}
        </div>
    );
};

export default SidebarCategories;
